import db from '@/db'

export enum TrainingMode {
  WORDS_FLASHCARDS = 'word-flashcards',
  READINGS_FLASHCARDS = 'reading-flashcards',
  MIXED_FLASHCARDS = 'mixed-flashcards',
  WORD_QUIZ = 'word-quiz',
  WORD_TO_READING_QUIZ = 'word-to-reading-quiz',
  READING_TO_WORD_QUIZ = 'reading-to-word-quiz',
}

type SystemExerciseId = 'mixed-flashcards' | 'word-quiz'

export type FlashcardExerciseData = {
  trainingMode: TrainingMode
  kanjiFilter?: string[]
}

export async function useExercise(exerciseId: string): Promise<FlashcardExerciseData | null> {
  // Handle system exercises
  if (
    ['mixed-flashcards', 'word-flashcards', 'reading-flashcards', 'word-quiz'].includes(exerciseId)
  ) {
    const exerciseConfig = {
      'mixed-flashcards': { trainingMode: TrainingMode.MIXED_FLASHCARDS, kanjiFilter: [] },
      'word-quiz': { trainingMode: TrainingMode.WORD_QUIZ, kanjiFilter: [] },
    }
    return exerciseConfig[exerciseId as SystemExerciseId]
  }

  // Handle custom exercises from database
  try {
    const exercise = await db.exercises.get(exerciseId)
    if (!exercise) {
      return null
    }

    let trainingMode: TrainingMode
    switch (exercise.mode) {
      case 'reading-flashcards':
        trainingMode = TrainingMode.READINGS_FLASHCARDS
        break
      case 'word-flashcards':
        trainingMode = TrainingMode.WORDS_FLASHCARDS
        break
      case 'mixed-flashcards':
        trainingMode = TrainingMode.MIXED_FLASHCARDS
        break
      case 'word-quiz':
        trainingMode = TrainingMode.WORD_QUIZ
        break
      case 'word-to-reading-quiz':
        trainingMode = TrainingMode.WORD_TO_READING_QUIZ
        break
      case 'reading-to-word-quiz':
        trainingMode = TrainingMode.READING_TO_WORD_QUIZ
        break
      default:
        trainingMode = TrainingMode.MIXED_FLASHCARDS
    }

    // Get kanji that match the exercise tags
    let kanjiFilter: string[] = []
    if (exercise.tags.length > 0) {
      const userKanjis = await db.userKanjis.where('tags').anyOf(exercise.tags).toArray()
      kanjiFilter = userKanjis.map((uk) => uk.kanji)
    }

    return {
      trainingMode,
      kanjiFilter,
    }
  } catch (error) {
    console.error('Error loading custom exercise:', error)
    return null
  }
}
